export const Script = ({ script, type = 'text/javascript' }: { script: string; type?: string }) => (
  <script
    type={type}
    dangerouslySetInnerHTML={{
      __html: script,
    }}
  />
);
